"use client";

import { useSettingProductTileIteration } from "@faire/retailer-visitor-shared/settings/useSettingProductTileIteration";
import { Column } from "@faire/web--source/slate/Layout/Column";

export const ProductInfoWrapper = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const showTileIterationChanges = useSettingProductTileIteration();
  return <Column gap={showTileIterationChanges ? 2 : 4}>{children}</Column>;
};
